import { render, staticRenderFns } from "./SplitPane.vue?vue&type=template&id=6250c4a8&"
import script from "./SplitPane.vue?vue&type=script&lang=js&"
export * from "./SplitPane.vue?vue&type=script&lang=js&"
import style0 from "./SplitPane.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports